import { useContext } from 'react';

import LoginContext from '../../../../../store/login-context';

import classes from './LoginSideNote.module.scss';
import DynamicText from '../../../../General/Static/DynamicText/DynamicText';

declare function Translate(key: string): string;
declare var _loginMethodPreRegCheckUrl;
declare var _curLang: any;

const LoginSideNote = () => {

    const ctx = useContext(LoginContext);

    const toRegForm = () => {         
        window.location = _loginMethodPreRegCheckUrl;
    };
    
    return (
        <div className={`${classes['side-container']} ${_curLang === 'ru' ? classes['side-container_ru'] : null}`}>
            <div className={classes.topContainer}>
                <h2 className={classes.side_sub_title}>{Translate('N_Login_donot_have_password')}</h2>            
                <div className={classes.side_text}>{Translate('N_Login_information')}</div>
                        
                <div className={classes.side_nopwd}>                    
                    <button id="regBtn" type="button" onClick={toRegForm} className={classes.side_btn}>{Translate('N_Login_to_sign_up')}</button>
                </div>
            </div>  

            <div className={classes.dynamic_text_container}>
                <DynamicText page="otp"/>
            </div>                                                  
        </div>
    );
};

export default LoginSideNote;